export default "__VITE_ASSET__BKiLcSEq__"